export default {
  functionKey: "MOYENNE",
  title: "MOYENNE",
  group: "Calcul",
  origin: [],
  target: [],
  targetRequired: true,
  multiOrigin: true,
  description: "Calcule la moyenne de plusieurs colonnes pour chaque ligne. Ajoutez les colonnes en Origine.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol, allOrigins = []) {
    const cols = allOrigins.length > 0 ? allOrigins : (origin ? [origin] : []);
    if (cols.length === 0) return { displayCode: '', safeCode: '' };
    const safeCode = `var _vals=[${cols.join(',')}].map(function(v){return parseFloat(v);}).filter(function(v){return !isNaN(v);}); ${destination}=_vals.length>0?String(_vals.reduce(function(a,b){return a+b;},0)/_vals.length):'';`;
    return { displayCode: safeCode, safeCode };
  }
}
